import { SYNC_RELEASE_NOTES } from '../../../constants/api'
import errorHandler from '../errorHandler'
import { IMemberReleaseNotesState } from '../../../common/models/ReleaseNote'

export default (token: string) =>
  fetch(SYNC_RELEASE_NOTES, {
    method: 'POST',
    headers: { Authorization: 'Bearer ' + token },
  })
    .then(errorHandler)
    .then(
      async (response: Response): Promise<IMemberReleaseNotesState | null> => {
        const { state } = await response.json()
        return state ? { ...state, since: new Date(state.since) } : null
      }
    )
